/* esm.sh - applesauce-common@5.2.0/dist/helpers/comment */
export * from "/*applesauce-common@5.2.0/esnext/dist/helpers/comment.mjs";
